import React, { useState } from 'react';
import './App.css';
import { Link } from 'react-router-dom';
import { supabase } from './supabase';

const mission = `To inspire holistic well-being, creativity, and conscious living through spiritual guidance, art, and community.`;
const vision = `A world where every individual feels empowered to live authentically, find their purpose, and contribute to a compassionate, connected global community.`;

const story = `Mana was born from a desire to blend ancient wisdom, modern healing, and creative expression. Our founder's journey through art, therapy, and multicultural experiences inspired a platform where people can access transformative tools, heartfelt mentorship, and a supportive community.`;

const values = [
  'Support for animal welfare and rescue initiatives',
  'Silent giving and acts of kindness',
  'Inclusivity and respect for all backgrounds',
  'Empowering personal growth and self-discovery',
  'Fostering creativity and mindful living'
];

const press = [
  { title: 'Featured in Spirituality Today Magazine', url: '#' },
  { title: 'Recognized by the International Healers Association', url: '#' },
  { title: 'Interviewed on The Mindful Path Podcast', url: '#' }
];

const socialLinks = [
  { name: 'Instagram', url: 'https://instagram.com/', icon: '📸' },
  { name: 'Facebook', url: 'https://facebook.com/', icon: '📘' },
  { name: 'YouTube', url: 'https://youtube.com/', icon: '▶️' },
  { name: 'Email', url: 'mailto:info@mana.com', icon: '✉️' }
];

function AboutMana() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    
    try {
      const contactData = {
        name: form.name,
        email: form.email,
        message: form.message,
        source: 'about_mana',
        status: 'new'
      };
      
      const { error } = await supabase
        .from('contact_messages')
        .insert([contactData]);
      
      if (error) throw error;
      
      setTimeout(() => {
        setSubmitted(false);
        setForm({ name: '', email: '', message: '' });
      }, 2500);
    } catch (error) {
      console.error('Error saving contact message:', error);
      setTimeout(() => {
        setSubmitted(false);
        setForm({ name: '', email: '', message: '' });
      }, 2500);
    }
  };

  return (
    <div className="main-bg">
      <header className="hero-section">
        <h1 className="site-title">About Mana</h1>
        <p className="site-tagline">The heart, story, and values behind our brand</p>
      </header>
      <div className="about-mana-container">
        <section className="about-mana-section">
          <h2>Mission & Vision</h2>
          <p><strong>Mission:</strong> {mission}</p>
          <p><strong>Vision:</strong> {vision}</p>
        </section>
        <section className="about-mana-section">
          <h2>The Story Behind the Brand</h2>
          <p>{story}</p>
        </section>
        <section className="about-mana-section">
          <h2>Community Values</h2>
          <ul className="about-mana-values">
            {values.map((v, i) => <li key={i}>{v}</li>)}
          </ul>
        </section>
        <section className="about-mana-section">
          <h2>Press & Recognition</h2>
          <ul className="about-mana-press">
            {press.map((p, i) => (
              <li key={i}><a href={p.url} target="_blank" rel="noopener noreferrer">{p.title}</a></li>
            ))}
          </ul>
        </section>
        <section className="about-mana-section">
          <h2>Contact Us</h2>
          <form className="about-mana-form" onSubmit={handleSubmit}>
            <input type="text" name="name" value={form.name} onChange={handleChange} placeholder="Your Name" required />
            <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="Your Email" required />
            <textarea name="message" value={form.message} onChange={handleChange} placeholder="Your Message" rows={3} required />
            <button type="submit" className="planner-btn">Send Message</button>
            {submitted && <div className="custom-success">Thank you! Your message has been sent.</div>}
          </form>
        </section>
      </div>
      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Life Force Dynamics. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default AboutMana; 